<template>
  <div>
    <!-- Navbar start -->
    <navbar-element></navbar-element>
    <!-- Navbar end -->

    <!-- Main section start -->
    <main-section></main-section>
    <!-- Main section end -->

    <!-- About section start -->
    <about-section></about-section>
    <!-- About section end -->

    <!-- Climbing wall section start -->
    <climbing-wall-section></climbing-wall-section>
    <!-- Climbing wall section end -->

    <!-- Games section start -->
    <games-section></games-section>
    <!-- Games section end -->

    <!-- Gallery section start -->
    <gallery-section></gallery-section>
    <!-- Gallery section end -->

    <!-- Contact section start -->
    <contact-section></contact-section>
    <!-- Contact section end -->

    <!-- Footer start -->
    <footer-element></footer-element>
    <!-- Footer end -->
  </div>
</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue'
import FooterElement from '@/components/FooterElement.vue'
import MainSection from '@/sections/MainSection.vue'
import AboutSection from '@/sections/AboutSection.vue'
import ClimbingWallSection from '@/sections/ClimbingWallSection.vue'
import GamesSection from '@/sections/GamesSection.vue'
import GallerySection from '@/sections/GallerySection.vue'
import ContactSection from '@/sections/ContactSection.vue'

export default {
  name: 'HomePageView',
  components: {
    NavbarElement,
    FooterElement,
    MainSection,
    AboutSection,
    ClimbingWallSection,
    GamesSection,
    GallerySection,
    ContactSection
  }
}
</script>
